<template>
  <div class="document-container">
    <div class="columns">
      <div class="column column-left is-paddingless">
        <div class="flex-container-left">
          <div>
            <router-view
                :pidAvailableReportTypes="pidAvailableReportTypes"
                @reportCreated="appendReport"></router-view>
          </div>
        </div>
      </div>
      <div class="column column-right is-one-quarter is-paddingless">
        <div class="flex-container-right">
          <div class="document-container">
            <div class="document" name="myActivity">
              <div class="header">
                <es-header>
                  <template #header>
                    <div class="header-title">My Activity</div>
                  </template>
                  <template #actions v-if="!loading">
                    <ul>
                      <li class="p-narrow no-border">
                        <div class="list-content">
                          <popper
                            ref="filter"
                            trigger="click"
                            :options="{
                              placement: 'left',
                              modifiers: { offset: { offset: '0,10px' } }
                            }">
                            <div class="popper">
                              <div class="filter-container" v-if="isLocModule()">
                                <div class="field is-horizontal">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel has-text-weight-bold">
                                          Report Name
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="field is-horizontal"
                                  v-if="hasModule('LOCID:REP:LOCATIONS')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                            name="reportTypeIdCheck"
                                            v-model="reportTypeIdCheck"
                                            :value="getReportTypeId('ALL_LOCATIONS')"
                                            @change="fetch()">
                                          All Locations Report
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="field is-horizontal"
                                  v-if="hasModule('LOCID:REP:LOCBYGROUP')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="getReportTypeId('GROUP_HEIRARCHY')"
                                          @change="fetch()">
                                          Location by Group with Hierarchy
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="field is-horizontal"
                                  v-if="hasModule('LOCID:REP:LOCALCODE')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="getReportTypeId('LOCAL_CODE')"
                                          @change="fetch()">
                                          Distinct Local Code Report
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="filter-container" v-if="isDmModule()">
                                <div class="field is-horizontal">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel has-text-weight-bold">
                                          Report Name
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="field is-horizontal"
                                  v-if="hasModule('DRMCH:REP:FNS834')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="getReportTypeId('FNS834')"
                                          @change="fetch()">
                                          FNS-834 Report
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('DRMCH:REP:MAYUSDA')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="getReportTypeId('MAY')"
                                          @change="fetch()">
                                          May Report to USDA
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('DRMCH:REP:POP')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="getReportTypeId('DM_POPULATION')"
                                          @change="fetch()">
                                          Population Data
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('DRMCH:REP:SEPTUSDA')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="getReportTypeId('SEPTEMBER')"
                                          @change="fetch()">
                                          September Report to USDA
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="field is-horizontal">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="getReportTypeId('LOCNSLP')"
                                          @change="fetch()">
                                          Locations Serving only NSLP with High ISP
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="filter-container" v-if="isPidModule()">
                                <div class="field is-horizontal">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel has-text-weight-bold">
                                          Report Name
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('PRSID:REP:ALIASID')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="aliasIdReportType
                                            ? aliasIdReportType.id : ''"
                                          @change="fetch()">
                                          Alias ID
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('PRSID:REP:CANCELED')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="canceledRecordReportType
                                            ? canceledRecordReportType.id : ''"
                                          @change="fetch()">
                                          Canceled Record
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('PRSID:REP:NEARMATCHBYLOC')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="nearMatchByLocationReportType
                                            ? nearMatchByLocationReportType.id : ''"
                                          @change="fetch()">
                                          Near Match By Location
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('PRSID:REP:NOHIST')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="noHistoryReportType
                                            ? noHistoryReportType.id : ''"
                                          @change="fetch()">
                                          No History
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                    class="field is-horizontal"
                                    v-if="hasModule('PRSID:REP:SUBMHIST')">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="control">
                                        <label class="popperlabel">
                                          <input type="checkbox"
                                          name="reportTypeIdCheck"
                                          v-model="reportTypeIdCheck"
                                          :value="submissionHistoryReportType
                                            ? submissionHistoryReportType.id : ''"
                                          @change="fetch()">
                                          Submission History
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="filter-container">
                                <div class="field is-horizontal">
                                  <div class="field-body">
                                    <div class="field">
                                      <div class="resetControl">
                                        <button @click="resetForm()" class="button button-link has-underline">
                                          Reset
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button class="button is-white" slot="reference" aria-label="Filter">
                              <span class="icon is-small">
                                  <font-awesome-icon :icon="['fal', 'filter']" title="Filter" />
                                </span>
                            </button>
                          </popper>
                        </div>
                      </li>
                    </ul>
                  </template>
                </es-header>
              </div>
              <div>
                <es-loader v-if="loading" style="margin: 3rem"/>
                <div v-if="!loading">
                  <div class="activity-row" v-for="userReport in reportList"
                  :key="userReport.id">
                    <div class="activity-row-container">
                      <div class="icon-column">
                        <div
                            class="activity-element"
                            v-bind:class="{ 'fa-stack': stackedReportIcons[userReport.reportId] }">
                          <font-awesome-icon
                            :icon="['fas', `${ reportIcons[userReport.reportId]}`]"
                            size="lg"
                            class="text-muted fa-lg"/>
                            <font-awesome-icon
                              v-if="stackedReportIcons[userReport.reportId]"
                              :icon="['fas', stackedReportIcons[userReport.reportId].icon]"
                              v-bind:style="stackedReportIcons[userReport.reportId].style"
                              size="lg"
                              class="text-muted fa-stack-1x" />
                        </div>
                      </div>
                      <div class="activity-summary">
                        <div class="activity-status activity-element">
                          <strong>
                            {{ reportTypes[userReport.reportId].name }}
                          </strong>

                          <span class="has-text-grey" v-if="!userReport.endDate">
                            report is generating. Click
                            <a @click="fetch()" @keypress.enter.prevent="fetch()" tabindex="0" role="button">
                              <font-awesome-icon :icon="['fas', 'sync-alt']" class="lg" title="Refresh" />
                            </a> to get the most current data.
                          </span>
                          <span class="has-text-grey" v-else>
                            report is ready to download
                          </span>
                        </div>
                        <div v-if="userReport.endDate"
                          class="activity-summary"
                          @click.prevent="downloadReport($event)"
                          :href="buildUrl(userReport)">
                            <div class="activity-element">
                              <a @click.prevent="downloadReport($event)"
                                :class="{ disabled: !hasDownloadPrivilege }"
                                :href="buildUrl(userReport)">
                                <font-awesome-icon
                                :icon="['fal', 'arrow-circle-down']"
                                size="lg" class="ml-1 mr-2"/>
                                  Start download
                              </a>
                            </div>
                            <div class="activity-element">
                              <font-awesome-icon
                                :icon="['fal', 'clock']"
                                class="ml-1 mr-2"/>
                                {{ userReport.endDate | formatDateMMDDYYYYHHMM }}
                            </div>
                        </div>
                        <div v-else div="activity-element">
                          <font-awesome-icon :icon="['fal', 'spinner']"
                            size="lg" class="ml-1 mr-2"/>
                            Generating
                        </div>
                        <div class="activity-element" v-if="!userReport.endDate">
                          <font-awesome-icon
                            :icon="['fal', 'clock']"
                            class="ml-1 mr-2"/>
                            {{ userReport.startDate | formatDateMMDDYYYYHHMM }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

import 'vue-popperjs/dist/vue-popper.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faTimes,
  faCheck,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faLandmarkFlag,
  faMapMarkerAlt,
  faNotEqual,
  faSpinner,
  faArrowCircleDown,
  faClock,
  faSitemap,
} from '@fortawesome/pro-light-svg-icons';
import {
  faAngleRight as faAngleRightSolid,
  faTimes as faTimesSolid,
  faCheck as faCheckSolid,
  faCheckCircle as faCheckCircleSolid,
  faEdit as faEditSolid,
  faEllipsisH as faEllipsisHSolid,
  faFilter as faFilterSolid,
  faLandmarkFlag as faLandmarkFlagSolid,
  faMapMarkerAlt as faMapMarkerAltSolid,
  faNotEqual as faNotEqualSolid,
  faSpinner as faSpinnerSolid,
  faArrowCircleDown as faArrowCircleDownSolid,
  faClock as faClockSolid,
  faSitemap as faSitemapSolid,
  faSyncAlt,
  faIdBadge,
  faWindowClose,
  faExclamationCircle,
  faHistory,
  faSlash,
} from '@fortawesome/pro-solid-svg-icons';
import Popper from 'vue-popperjs';

import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';

import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

let fetchType;

library.add(
  faAngleRight,
  faTimes,
  faCheck,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFilter,
  faMapMarkerAlt,
  faNotEqual,
  faSpinner,
  faArrowCircleDown,
  faClock,
  faSitemap,
  faAngleRightSolid,
  faTimesSolid,
  faCheckSolid,
  faCheckCircleSolid,
  faEditSolid,
  faEllipsisHSolid,
  faFilterSolid,
  faLandmarkFlag,
  faLandmarkFlagSolid,
  faMapMarkerAltSolid,
  faNotEqualSolid,
  faSpinnerSolid,
  faArrowCircleDownSolid,
  faClockSolid,
  faSitemapSolid,
  faSyncAlt,
  faIdBadge,
  faWindowClose,
  faExclamationCircle,
  faHistory,
  faSlash,
);

export default {
  mixins: [
    BreadcrumbsManager,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsHeader,
    EsLoader,
    Popper,
  },
  data() {
    return {
      intervalId: null,
      reportList: [],
      unfilteredreportList: [],
      status: '',
      reportType: '',
      delim: '',
      qual: '',
      loading: true,
      isSuccessGenerate: false,
      reportTypeIdCheck: [],
      messages: [],
      locReportTypes: [],
      dmReportTypes: [],
      pidReportTypes: [],
      reportTypes: {},
      reportIcons: {},
      stackedReportIcons: {},
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from && from.query.showSuccessMessage && !to.query.showSuccessMessage) {
        this.messages.push('The report is being generated. Go to My Activity panel to download the report when available.');
        this.showNotification('success', this.messages);
      }
    },
  //   reportIsGenerating() {
  //     try {
  //       if (this.reportIsGenerating) {
  //         this.intervalId = setInterval(async () => this.fetch(), 5000);
  //       } else {
  //         clearInterval(this.intervalId);
  //       }
  //     } catch (err) {
  //     }
  //   },
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    ...mapGetters('lookups', [
      'pidAvailableReportTypes',
      'nearMatchByLocationReportType',
      'canceledRecordReportType',
      'aliasIdReportType',
      'submissionHistoryReportType',
      'noHistoryReportType',
    ]),
    hasDownloadPrivilege() {
      if (this.activeModule.name === 'locationID') {
        return this.hasModule('LOCID:DWNLD:DOWNLOAD');
      }
      if (this.activeModule.name === 'directMatch') {
        return this.hasModule('DRMCH:DWNLD:DOWNLOAD');
      }
      if (this.activeModule.name === 'personId') {
        return this.hasModule('PRSID:DWNLD:DOWNLOAD');
      }
      return false;
    },
    reportIsGenerating() {
      return this.reportList.some(report => !report.endDate);
    },
  },
  async created() {
    if (this.isPidModule()) {
      const availableReports = await this.loadPidAvailableReportTypes();

      this.reportTypes = {};
      this.reportIcons = {};
      this.stackedReportIcons = {};

      availableReports.forEach((r) => {
        this.reportTypes[r.id] = r;
        switch (r.code) {
          case 'PID_NML':
            this.reportIcons[r.id] = 'exclamation-circle';
            break;
          case 'PID_CANCELED':
            this.reportIcons[r.id] = 'window-close';
            break;
          case 'PID_ALIAS':
            this.reportIcons[r.id] = 'id-badge';
            break;
          case 'PID_SUB_HIST':
            this.reportIcons[r.id] = 'history';
            break;
          case 'PID_NO_HIST':
            this.reportIcons[r.id] = 'history';
            this.stackedReportIcons[r.id] = {
              icon: 'slash',
              style: {
                marginLeft: '-2px',
              },
            };
            break;
          default:
            break;
        }
        this.pidReportTypes.push(r.id.toString());
      });
    } else {
      if (this.isDmModule()) {
        fetchType = 'dm';
      } else if (this.isLocModule()) {
        fetchType = 'loc';
      }
      const data = await axios.get('/reports/types', {
        params: {
          fT: fetchType,
        },
      });

      data.data.forEach((type) => {
        if (type.code !== 'CEP_ROSTER') {
          this.reportTypes[type.id] = type;
          this.addReportInformation(type);
        }
      });
    }
    this.fetch();
  },
  mounted() {
    if (this.$router.currentRoute.query.showSuccessMessage) {
      this.$router.replace({ query: {} });
    }
    this.setBreadcrumbs();
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidAvailableReportTypes',
    ]),
    setBreadcrumbs() {
      if (this.activeModule.name === 'locationID') {
        this.setBreadcrumb([
          { text: 'Home', to: { name: 'groupList' } },
          { text: 'Reports', to: {} },
        ]);
      } else if (this.activeModule.name === 'personId') {
        this.setBreadcrumb([
          { text: 'Home', to: { name: 'pidDashboard' } },
          { text: 'Reports', to: {} },
        ]);
      } else {
        this.setBreadcrumb([
          { text: 'Home', to: { name: 'dmDashboard' } },
          { text: 'Reports', to: {} },
        ]);
      }
    },
    appendReport() {
      this.fetch();
      this.messages.push('The report is being generated. Go to My Activity panel to download the report when available.');
      this.showNotification('success', this.messages);
    },
    updateReportStatus(report) {
      const indexValue = this.findarrayindex(report);

      let pushReport = false;

      if (indexValue === -1) {
        if (this.isLocModule()) {
          if (this.locReportTypes.indexOf(`${report.reportId}`) > -1) {
            pushReport = true;
          }
        } else if (this.isDmModule()) {
          if (this.dmReportTypes.indexOf(`${report.reportId}`) > -1) {
            pushReport = true;
          }
        } else if (this.isPidModule()) {
          if (this.pidReportTypes.indexOf(`${report.reportId}`) > -1) {
            pushReport = true;
          }
        }

        if (pushReport) {
          this.unfilteredreportList.unshift(report);
          this.isSuccessGenerate = true;
          this.messages.push('The report has been generated. Go to My Activity panel to download the report.');
          this.showNotification('success', this.messages);
        }
      } else {
        this.unfilteredreportList.splice(indexValue, 1, report);
        this.messages.push('The report has been generated. Go to My Activity panel to download the report.');
        this.showNotification('success', this.messages);
      }
      this.reportList = this.unfilteredreportList;
    },
    downloadReport(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    buildUrl(report) {
      if (this.isPidModule()) {
        const reportType = this.pidAvailableReportTypes.find(r => r.id === report.reportId);
        return `${axios.defaults.baseURL}personid/reports/${reportType.code}/${report.id}/download`;
      }
      if (this.isLocModule() || this.isDmModule()) {
        if (Object.hasOwn(this.reportTypes, report.reportId)) {
          const reportType = this.reportTypes[report.reportId].code;
          return `${axios.defaults.baseURL}reports/${reportType}/${report.id}/download`;
        }
      }
      console.log('unrecognized module not handled in ReportsMyActivity!');
      return null;
    },
    async fetch() {
      try {
        this.loading = true;
        let res = null;

        const reportTypes = Object.values(this.reportTypes)
          .filter(type => !this.reportTypeIdCheck || !this.reportTypeIdCheck.length || this.reportTypeIdCheck.includes(type.id))
          .map(type => type.code)
          .join(',');

        if (this.activeModule.name === 'personId') {
          const reports = await axios.get('/personid/reports/user', {
            params: {
              pageNum: 1,
              pageSize: 5,
              reportType: reportTypes,
            },
          });

          res = reports;
        } else {
          if (this.isDmModule()) {
            fetchType = 'dm';
          } else if (this.isLocModule()) {
            fetchType = 'loc';
          }

          res = await axios.get('/reports/user-generated', {
            params: {
              pageSize: 5,
              fT: fetchType,
              reportType: reportTypes,
            },
          });
        }

        this.reportList = res.data.data;
        this.unfilteredreportList = this.reportList;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    isLocModule() {
      return (this.activeModule.name === 'locationID');
    },
    isDmModule() {
      return (this.activeModule.name === 'directMatch');
    },
    isPidModule() {
      return (this.activeModule.name === 'personId');
    },
    findarrayindex(report) {
      const reportIdToFind = element => element.id === report.id;
      return this.unfilteredreportList.findIndex(reportIdToFind);
    },
    resetForm() {
      if (this.reportTypeIdCheck && this.reportTypeIdCheck.length) {
        this.reportTypeIdCheck = [];
        this.fetch();
      }
    },
    addReportInformation(reportType) {
      switch (reportType.code) {
        case 'ALL_LOCATIONS':
          this.reportIcons[reportType.id] = 'map-marker-alt';
          break;
        case 'GROUP_HEIRARCHY':
          this.reportIcons[reportType.id] = 'sitemap';
          break;
        case 'LOCAL_CODE':
          this.reportIcons[reportType.id] = 'not-equal';
          break;
        case 'FNS834':
          this.reportIcons[reportType.id] = 'landmark-alt';
          break;
        case 'MAY':
          this.reportIcons[reportType.id] = 'landmark';
          break;
        case 'SEPTEMBER':
          this.reportIcons[reportType.id] = 'school';
          break;
        case 'LOCNSLP':
          this.reportIcons[reportType.id] = 'building';
          break;
        case 'DM_POPULATION':
          this.reportIcons[reportType.id] = 'landmark-flag';
          break;
        default:
          break;
      }
      if (this.isLocModule()) {
        this.locReportTypes.push(reportType.id.toString());
      } else if (this.isDmModule()) {
        this.dmReportTypes.push(reportType.id.toString());
      }
    },
    getReportTypeId(reportTypeCode) {
      const reportType = Object.values(this.reportTypes).filter(rt => rt.code === reportTypeCode);
      return reportType && reportType.length ? reportType[0].id : 0;
    },
  },
};
</script>

<style lang="sass" scoped>
  .popper
    width: 250px
  .popperlabel
    padding: 5px
    text-align: left
    flex-wrap: nowrap
    overflow-x: auto
  .filter-container
    padding: 5px
  .resetControl
    text-align: right
    font-size: .85rem
  .text-muted
    color: #6c757d !important
  .activity-row
    border-top: 1px solid rgb(222, 226, 230)
  .activity-row-container
    padding: .5rem 1rem
    display: flex
  .icon-column
    min-width: 40px
    display: flex
    align-items: flex-start
  .activity-summary
    font-size: .85rem
    display: flex
    flex-direction: column
    align-items: flex-start
  .activity-element
    padding-top: 4px
    padding-bottom: 4px
    text-align: left
  .activity-status
    text-align: left
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
  iframe
    display: none
</style>
